/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
export const Footer = () => {
  return (
    <div>
      <div>
        <footer className="main-footer App">
          <strong>
            Copyright © 2025 <a href="#">Panaderia y Reposteria Monsalve. </a>
          </strong>
          Todos los derechos reservados.
          <div className="float-right d-none d-sm-inline-block">
            <b>Desarrollado por: </b> Gustavo Erazo
          </div>
        </footer>
      </div>
    </div>
  );
};
